import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getAllAtmedBookingClinic, getAtmedBookingClinic,
} from '../../../store/actions';
import Booking from './booking';

const mapStateToProps = ({ vendorEquipmenReducer }) => ({
  results: vendorEquipmenReducer.results
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getAllAtmedBookingClinic,
    getAtmedBookingClinic
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
